/*==========================================================
LAZY LOAD INIT SCRIPT
==========================================================*/
function lazyload() {
    // Lazy Loading Images
    if (typeof $.lazy === "function") {
        $(".lazy").lazy({
            visibleOnly: true,
            afterLoad: function (element) {
                element.addClass("loaded");
            }
        });
    }
}

lazyload();